// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"14dcb56e","453":"dab859f8","796":"026a6153"}[chunkId] + ".chunk.js";
};